<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <el-card>
        <div class="f-right border-b">
          <el-button v-hasPermi="['fireArchivesInfo:fireArchivesInfo:addFireFighting']" icon="el-icon-plus" type="primary" @click="addList()">新增</el-button>
        </div>
        <!-- <ul class="tab-wrap mt20" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->
        <table class="common-table mt20">
          <thead>
            <tr class="mt10">
              <th>所在位置</th>
              <th>使用性质</th>
              <th>建筑面积</th>
              <th>耐火等级</th>
              <th>责任人姓名</th>
              <th>电话</th>

              <th v-hasPermi="['safe:safearea:edit']">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="index">
              <td class="common-add">
                <el-input placeholder="请输入" v-model="item.zdAddress"></el-input>
              </td>
              <td class="common-add">
                <el-select v-model="item.zdNature" filterable="">
                  <el-option :label="item.dictLabel" :key="index" :value="item.dictValue" v-for="(item, index) in natureList"> </el-option>
                </el-select>
              </td>
              <td class="common-add">
                <el-input placeholder="请输入" v-model="item.zdArea"></el-input>
              </td>
              <td class="common-add">
                <el-input placeholder="请输入" v-model="item.zdLevel"></el-input>
              </td>
              <td class="common-add">
                <el-input placeholder="请输入" v-model="item.zdDutyName"></el-input>
              </td>
              <td class="common-add">
                <el-input placeholder="请输入" v-model="item.zdDutyPhone"></el-input>
              </td>
              <td class="td-btn">
                <a class="clear-data" @click="del(index)">
                  <i class="icon-tr-delete"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="btn-box">
          <div class="l-btn" v-hasPermi="['fireArchivesInfo:fireArchivesInfo:addFireFighting']" @click="onSubmit">保存</div>
          <div class="l-btn ml20" @click="$router.back()">返回</div>
        </div>
        <!-- <el-table :data="list" class="mt10" >
                    <el-table-column
                            type="index"
                            label="序号"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="tr_role_value"
                            label="姓名或微信昵称"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="tr_create_time"
                            align="center"
                            label="任务数量">
                    </el-table-column>
                      <el-table-column
                            prop="tr_create_time"
                            align="center"
                            label="报告数量">
                    </el-table-column>
                        <el-table-column
                            prop="tr_create_time"
                            align="center"
                            label="最后一次登录时间">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="160px">
                        <template slot-scope="scope">
                            <el-button size="mini" type="success" @click="edit(scope.row)">修改</el-button>
                            <el-popconfirm title="确定删除该条内容吗？" @confirm="del(scope.row)">
                                <el-button size="mini" type="danger" slot="reference">删除</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table> -->
      </el-card>
    </el-col>
    <!-- <el-col :span="12">
      <el-card>
        <div class="f-right border-b">
          <div class="flex1">巡查时间管理</div>
          <el-button icon="el-icon-plus" type="primary" @click="addList1()"
            >增加</el-button
          >
        </div>
        <table class="common-table mt20">
          <thead>
            <tr class="mt10">
              <th>巡查时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list1" :key="index">
              <td class="common-add">
                <el-time-picker
                  class="flex1"
                  type="time"
                  value-format="HH:mm:ss"
                  placeholder="选择时间"
                  v-model="item.start_time"
                ></el-time-picker>
              </td>
              <td class="common-add">
                <el-select v-model="item.z_status">
                  <el-option :value="1" label="启用"></el-option>
                  <el-option :value="0" label="停用"></el-option>
                </el-select>
              </td>
              <td class="td-btn">
                <a class="clear-data" @click="del1(index)">
                  <i class="icon-tr-delete"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
         <div class="btn-box">
                <div class="l-btn" @click="onSubmit1">保存</div>
                <div class="l-btn ml20" @click="$router.back()">返回</div>
            </div>
      </el-card>
    </el-col> -->
  </el-row>
</template>

<script>
export default {
  props: ["dictValue"],
  data() {
    return {
      list: [{ x_company_area: "", x_company_id: "" }],
      listWW: [],
      cNum: this.$route.query.id,
      natureList: [],
      tabList: this.$store.state.user.userInfo.isWenwu ? [{ name: "文物巡查", id: 1 }] : [{ name: "消防巡查", id: 0 }],

      nowIndex: 0,

      list1: [{ start_time: "", z_status: 1 }],
    };
  },
  watch: {
    "$route.query.id"(val) {
      if (val) {
        this.cNum = val;
        this.getList();
      }
    },
    dictValue() {},
  },
  created() {
    this.getList();
    this.$get("/system/dict/data/notPageList/", { dictType: "fire_protection_nature" }).then((res) => {
      console.log(res);
      this.natureList = res.data;
    });
    // this.getDatas()
  },
  methods: {
    onSubmit() {
      this.$post("/fireArchives/Archives/addFireFightingPartsList", { companyNum: this.cNum, companyEmphasisList: this.list }).then((res) => {
        // this.$message.success("操作成功");
         this.$message({
									message: '操作成功',
									type: 'success',
									duration: 700,
								});
      });
    },

    check() {
      var checked = true;

      if (this.list.length) {
        this.list.map((item) => {
          if (!item.x_company_id) {
            this.nowIndex = 0;
            this.$message.warning("请输入唯一标识");
            checked = false;
          }
        });

        return checked;
      } else {
        return checked;
      }
    },
    getDatas() {
      if (this.nowIndex == 0) {
        this.getList();
      } else {
        this.getWWlist();
      }
    },
    getWWlist() {
      this.$post("/xuncha/xunchaareadetailWenWu", {
        c_company_num: this.$store.state.user.company.cCompanyNum,
      }).then((res) => {
        console.log(res);
        this.listWW = res.data;
      });
    },
    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{

      // })
      this.$get(`fireArchives/Archives/fireFightingPartsList/${this.cNum}`).then((res) => {
        console.log(res);
        this.list = res.data;
      });
      // this.$post('/xuncha/xunchatimedetail').then(res=>{
      //               // return
      //               this.list1=res.data || []

      //           })
    },
    del(index) {
      if (this.list[index].x_company_area && this.list[index].x_company_id) {
        var x_company_id = this.list[index].x_company_id;
        this.$post("/xuncha/xcareaExist", {
          x_company_id,
          inspectionType: 1,
        }).then((res) => {
          if (res.code < 1000) {
            if (res.data == false) {
              this.list.splice(index, 1);
            } else {
              this.$message.warning(res.msg);
            }
          }
        });
      } else {
        this.list.splice(index, 1);
      }
    },
    del1(index) {
      if (this.listWW[index].x_company_area && this.listWW[index].x_company_id) {
        var x_company_id = this.listWW[index].x_company_id;
        this.$post("/xuncha/xcareaExist", {
          x_company_id,
          inspectionType: 2,
        }).then((res) => {
          if (res.code < 1000) {
            if (res.data == false) {
              this.listWW.splice(index, 1);
            } else {
              this.$message.warning(res.msg);
            }
          }
        });
      } else {
        this.listWW.splice(index, 1);
      }
    },
    addList() {
      this.list.unshift({
        id: 0,
        status: 0,
        zdAddress: "",
        zdArea: "",
        zdCompanyNum: this.cNum,
        zdDutyName: "",
        zdDutyPhone: "",
        zdLevel: "",
        zdNature: "",
      });
    },
    addList1() {
      this.list1.push({ start_time: "", z_status: 1 });
    },
  },
};
</script>

<style scoped></style>
